/* Basic panel toggle logic for RPS nav.
 * - Click opens/closes, hover supported via data-trigger.
 * - Tabs inside panels switch on click.
 * - ESC and outside click close panels.
 */
(function ($) {
	'use strict';

	var cfg = window.rpsNavCfg || {};
	// Mobile/tablet breakpoints (px). Keep easy to find and update.
	var mobileBp = 768;
	var tabletBp = 1200;
	var drawerBp = Math.max(mobileBp, tabletBp);

	function closeAll($nav) {
		$nav.find('.has-nav-panel > a[aria-expanded="true"]').each(function () {
			var $trigger = $(this);
			var panelId = $trigger.data('nav-panel');
			$trigger.attr('aria-expanded', 'false');
			$trigger.closest('li').removeClass('is-open');
			if (panelId) {
				var $scope = $trigger.closest('.site-header');
				var $panel = $scope.length ? $scope.find('#' + panelId).first() : $('#' + panelId);
				$panel.removeClass('is-open');
			}
			$trigger.removeClass('is-open');
		});
	}

	function openPanel($trigger) {
		var panelId = $trigger.data('nav-panel');
		if (!panelId) return;
		$trigger.attr('aria-expanded', 'true').addClass('is-open');
		$trigger.closest('li').addClass('is-open');
		var $scope = $trigger.closest('.site-header');
		var $panel = $scope.length ? $scope.find('#' + panelId).first() : $('#' + panelId);
		$panel.addClass('is-open');
		ensureFirstTab($panel);
	}

	function initTabs($panel) {
		var $tabs = $panel.find('.rps-panel__tab');
		var $panes = $panel.find('.rps-panel__tabpane');

		$tabs.on('click', function (e) {
			e.preventDefault();
			var $btn = $(this);
			var target = $btn.data('target');

			$tabs.removeClass('is-active').attr('aria-selected', 'false');
			$btn.addClass('is-active').attr('aria-selected', 'true');

			$panes.removeClass('is-active').attr('hidden', 'hidden');
			$('#' + target).addClass('is-active').removeAttr('hidden');
		});
	}

	function bindNav($nav) {
		initTabs($nav.find('.rps-mega-panel'));

		$nav.on('click', '.has-nav-panel > a', function (e) {
			var $trigger = $(this);
			if (isDrawerActive() && cfg.mobileMode === 'offcanvas') {
				e.preventDefault();
				openDrilldown($trigger);
				return;
			}
			var triggerMode = isDrawerActive() ? 'click' : ($trigger.data('trigger') || cfg.triggerDefault || 'click');
			if (triggerMode === 'hover') {
				return;
			}
			e.preventDefault();
			var isOpen = $trigger.attr('aria-expanded') === 'true';
			closeAll($nav);
			if (!isOpen) {
				openPanel($trigger);
			}
			e.stopPropagation();
		});

		$nav.on('mouseenter', '.has-nav-panel > a', function () {
			var $trigger = $(this);
			var triggerMode = $trigger.data('trigger') || cfg.triggerDefault || 'click';
			if (isDrawerActive()) return;
			if (triggerMode !== 'hover') return;
			closeAll($nav);
			openPanel($trigger);
		});

		$nav.on('mouseleave', '.has-nav-panel', function () {
			var $trigger = $(this).children('a').first();
			var triggerMode = $trigger.data('trigger') || cfg.triggerDefault || 'click';
			if (triggerMode !== 'hover') return;
			closeAll($nav);
		});

		$nav.on('click', '.rps-mega-panel', function (e) {
			if ($(e.target).closest('[data-nav-mobile-back],[data-nav-mobile-close],.rps-panel__tab').length) {
				return;
			}
			e.stopPropagation();
		});

		if (cfg.closeOnLinkClick) {
			$nav.on('click', '.rps-mega-panel a', function () {
				closeAll($nav);
			});
		}

		if (cfg.closeOnOutside !== false) {
			$(document).on('click', function () {
				closeAll($nav);
			});
		}

		if (cfg.escCloses !== false) {
			$(document).on('keydown', function (e) {
				if (e.key === 'Escape') {
					closeAll($nav);
				}
			});
		}

		if (cfg.focusTrap) {
			$(document).on('keydown', function (e) {
				if (e.key !== 'Tab') return;
				var $openPanel = $nav.find('.rps-mega-panel.is-open').first();
				if (!$openPanel.length) return;
				var $focusables = $openPanel.find('a,button,[tabindex]:not([tabindex="-1"])').filter(':visible');
				if (!$focusables.length) return;
				var first = $focusables[0], last = $focusables[$focusables.length - 1];
				if (e.shiftKey && document.activeElement === first) {
					e.preventDefault();
					last.focus();
				} else if (!e.shiftKey && document.activeElement === last) {
					e.preventDefault();
					first.focus();
				}
			});
		}

		$nav.on('click', '.rps-panel__close', function () {
			closeAll($nav);
		});

	}

	function isDrawerActive() {
		return window.innerWidth < drawerBp;
	}

	function bindNavDrawer() {
		var $drawer = $('[data-nav-drawer]');
		var $overlay = $('[data-nav-overlay]');
		var $toggle = $('[data-nav-toggle]');
		if (!$drawer.length || !$toggle.length) return;
		var $collapse = $drawer.find('.navbar-collapse');
		var $rootBack = $drawer.find('[data-nav-root-back]');
		var $siteHeader = $drawer.closest('.site-header');
		var $topbar = $siteHeader.find('.rps-topbar');
		var $mainNav = $siteHeader.find('.main-nav');

		function syncPanelOffset() {
			if (!$siteHeader.length || !$mainNav.length) return;
			var headerTop = Math.max(0, $siteHeader[0].getBoundingClientRect().top || 0);
			var topbarVisible = $topbar.length && !$topbar.hasClass('is-hidden');
			var topbarH = topbarVisible ? ($topbar.outerHeight() || 0) : 0;
			var mainNavH = $mainNav.outerHeight() || 0;
			var offset = headerTop + topbarH + mainNavH;
			$siteHeader.css('--panel-offset', offset + 'px');
		}

		function openDrawer() {
			syncPanelOffset();
			$('body').addClass('nav-drawer-open');
			$toggle.attr('aria-expanded', 'true');
			$collapse.addClass('show').attr('aria-hidden', 'false');
			setDrawerLevel(1);
		}

		function closeDrawer() {
			$('body').removeClass('nav-drawer-open');
			$toggle.attr('aria-expanded', 'false');
			$collapse.removeClass('show').attr('aria-hidden', 'true');
			setDrawerLevel(1);
			$drawer.removeAttr('data-has-tabs');
			closeAll($('.navbar-nav'));
		}

		$toggle.on('click', function (e) {
			e.preventDefault();
			if ($('body').hasClass('nav-drawer-open')) {
				closeDrawer();
			} else {
				openDrawer();
			}
		});

		$rootBack.on('click', function () {
			closeDrawer();
		});

		$overlay.on('click', function () {
			closeDrawer();
		});

		$(window).on('resize', function () {
			syncPanelOffset();
			if (!isDrawerActive()) {
				closeDrawer();
			}
		});

		$(document).on('keydown', function (e) {
			if (e.key === 'Escape') {
				closeDrawer();
			}
		});

		syncPanelOffset();
	}

	function setDrawerLevel(level) {
		var $drawer = $('[data-nav-drawer]');
		if (!$drawer.length) return;
		$drawer.attr('data-level', level);
	}

	function openDrilldown($trigger) {
		var panelId = $trigger.data('nav-panel');
		if (!panelId) return;
		var $drawer = $trigger.closest('[data-nav-drawer]');
		var $panel = $drawer.find('#' + panelId).first();
		if (!$panel.length) return;
		var parentTitle = $trigger.text().trim();

		closeAll($('.navbar-nav'));
		$drawer.find('.rps-mega-panel.is-open').removeClass('is-open').removeAttr('data-mobile-panel');
		$panel.addClass('is-open').attr('data-mobile-panel', 'true');
		ensureMobileHeader($panel, parentTitle);
		ensureTabHeader($panel);
		ensureFirstTab($panel);

		var isTabbed = $panel.find('.rps-panel__tablist').length > 0;
		if (isTabbed) {
			$drawer.attr('data-has-tabs', 'true');
		} else {
			$drawer.removeAttr('data-has-tabs');
		}
		setDrawerLevel(2);
		if (isTabbed) {
			var $activeTab = $panel.find('.rps-panel__tab.is-active').first();
			if ($activeTab.length) {
				setTabHeaderTitle($panel, $activeTab.text().trim());
			}
		}
	}

	function ensureMobileHeader($panel, title) {
		var $header = $panel.find('.rps-panel__mobile-header');
		if ($header.length) {
			$panel.attr('data-parent-title', title);
			setPanelHeaderTitle($panel, title);
			return;
		}
		$header = $('<div class="rps-panel__mobile-header" />');
		var $back = $('<button type="button" class="rps-panel__mobile-back" data-nav-mobile-back>Back</button>');
		var $title = $('<span class="rps-panel__mobile-title" data-nav-mobile-title />').text(title);
		var $close = $('<button type="button" class="rps-panel__mobile-close" data-nav-mobile-close aria-label="Close menu">&times;</button>');
		$header.append($back, $title, $close);
		$panel.prepend($header);
		$panel.attr('data-parent-title', title);
	}

	function ensureTabHeader($panel) {
		var $container = $panel.find('.rps-panel__tabpanes-container');
		if (!$container.length) return;
		var $header = $container.find('.rps-panel__tab-header');
		if ($header.length) return;
		$header = $('<div class="rps-panel__tab-header" />');
		var $back = $('<button type="button" class="rps-panel__mobile-back" data-nav-mobile-back>Back</button>');
		var $title = $('<span class="rps-panel__mobile-title" data-nav-mobile-tab-title />');
		var $close = $('<button type="button" class="rps-panel__mobile-close" data-nav-mobile-close aria-label="Close menu">&times;</button>');
		$header.append($back, $title, $close);
		$container.prepend($header);
	}

	function setPanelHeaderTitle($panel, title) {
		var $header = $panel.find('.rps-panel__mobile-header');
		if (!$header.length) return;
		$header.find('[data-nav-mobile-title]').text(title || '');
	}

	function setTabHeaderTitle($panel, title) {
		var $header = $panel.find('.rps-panel__tab-header');
		if (!$header.length) return;
		$header.find('[data-nav-mobile-tab-title]').text(title || '');
	}

	function bindMobileDrilldown() {
		var $drawer = $('[data-nav-drawer]');
		if (!$drawer.length) return;

		$drawer.on('click', '[data-nav-mobile-back]', function () {
			var level = parseInt($drawer.attr('data-level') || '1', 10);
			var $panel = $drawer.find('.rps-mega-panel.is-open').first();
			var hasTabs = $panel.find('.rps-panel__tablist').length > 0;
			if (level === 3 && hasTabs) {
				setDrawerLevel(2);
				setPanelHeaderTitle($panel, $panel.attr('data-parent-title') || '');
			} else {
				setDrawerLevel(1);
				$drawer.removeAttr('data-has-tabs');
				closeAll($('.navbar-nav'));
			}
		});

		$drawer.on('click', '[data-nav-mobile-close]', function () {
			$('[data-nav-toggle]').trigger('click');
		});

		$drawer.on('click', '.rps-panel__tab', function () {
			if (!isDrawerActive() || cfg.mobileMode !== 'offcanvas') return;
			var $panel = $(this).closest('.rps-mega-panel');
			var tabLabel = $(this).text().trim();
			$drawer.attr('data-has-tabs', 'true');
			setTabHeaderTitle($panel, tabLabel);
			setDrawerLevel(3);
		});
	}

	function ensureFirstTab($panel) {
		var $tabs = $panel.find('.rps-panel__tab');
		if (!$tabs.length) return;
		var $activeTab = $tabs.filter('.is-active');
		if ($activeTab.length) return;

		var $first = $tabs.first();
		var target = $first.data('target');
		$tabs.removeClass('is-active').attr('aria-selected', 'false');
		$first.addClass('is-active').attr('aria-selected', 'true');

		var $panes = $panel.find('.rps-panel__tabpane');
		$panes.removeClass('is-active').attr('hidden', 'hidden');
		if (target) {
			var $pane = $panel.find('#' + target);
			$pane.addClass('is-active').removeAttr('hidden');
		}
	}


	function bindTopBar() {
		if (!cfg.topBarEnabled || !cfg.topBarHideOnScroll) return;
		var $topbar = $('.rps-topbar');
		if (!$topbar.length) return;

		var $siteHeader = $topbar.closest('.site-header');
		if (!$siteHeader.length) return;
		var $mainNav = $siteHeader.find('.main-nav');

		function syncTopbarHeight() {
			var h = $topbar.outerHeight() || 0;
			$siteHeader.css('--topbar-height', h + 'px');
			syncPanelOffset();
		}

		function syncPanelOffset() {
			var headerTop = Math.max(0, $siteHeader[0].getBoundingClientRect().top || 0);
			var topbarVisible = !$topbar.hasClass('is-hidden');
			var topbarH = topbarVisible ? ($topbar.outerHeight() || 0) : 0;
			var mainNavH = $mainNav.outerHeight() || 0;
			var offset = headerTop + topbarH + mainNavH;
			$siteHeader.css('--panel-offset', offset + 'px');
		}

		syncTopbarHeight();

		var lastScroll = window.scrollY || 0;
		$(window).on('scroll', function () {
			var current = window.scrollY || 0;
			if (current > lastScroll && current > 80) {
				$topbar.addClass('is-hidden');
				$siteHeader.addClass('topbar-hidden');
			} else {
				$topbar.removeClass('is-hidden');
				$siteHeader.removeClass('topbar-hidden');
			}
			syncPanelOffset();
			lastScroll = current;
		});

		$(window).on('resize', syncTopbarHeight);
	}

	function bindTopBarDropdown() {
		var $topbar = $('.rps-topbar--standard');
		if (!$topbar.length) return;

		var triggerMode = cfg.triggerDefault || 'click';

		function closeDropdowns() {
			$topbar.find('.menu-item-has-children.is-open').removeClass('is-open');
		}

		if (triggerMode === 'hover') {
			$topbar.on('mouseenter', '.menu-item-has-children', function () {
				$(this).addClass('is-open');
			});
			$topbar.on('mouseleave', '.menu-item-has-children', function () {
				$(this).removeClass('is-open');
			});
		} else {
			$topbar.on('click', '.menu-item-has-children > a', function (e) {
				e.preventDefault();
				var $item = $(this).closest('.menu-item-has-children');
				if ($item.hasClass('is-open')) {
					$item.removeClass('is-open');
				} else {
					closeDropdowns();
					$item.addClass('is-open');
				}
				e.stopPropagation();
			});

			$(document).on('click', function () {
				closeDropdowns();
			});

			$(document).on('keydown', function (e) {
				if (e.key === 'Escape') {
					closeDropdowns();
				}
			});
		}
	}

	$(function () {
		var $nav = $('.navbar-nav');
		if (!$nav.length) return;

		var $header = $nav.closest('.site-header');
		if ($header.length && (cfg.triggerDefault || 'click') === 'hover') {
			$header.addClass('nav-hover');
		}

		$nav.attr('data-mobile-mode', cfg.mobileMode || 'offcanvas');
		bindNav($nav);
		bindNavDrawer();
		bindTopBar();
		bindTopBarDropdown();
		bindMobileDrilldown();
	});
})(jQuery);
